module.exports = __webpack_public_path__ + "static/media/Flowerpot Girl.d5108355.jpg";